import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { OrderLine } from '@models/order';
import { useTranslation } from 'react-i18next';

import SoldOut from './SoldOut';

interface Props {
    item: OrderLine;
}

function CartImage({ item }:Props) {
    const { t } = useTranslation('cart');
    const { itemImageUrl, status } = item;
    const isSoldOut = status === 'SOLD_OUT';
    const disabled = status === 'PENDING' || status === 'DISCONTINUED';
    return (
        <ImageCard >
            <Thumbnail src={itemImageUrl}
                width={100}
                height={100}
                alt={t('item.imageAlt')} />
            {isSoldOut && (
                <SoldOut/>
            )}
            {disabled && (
                <Disabled>
                    <Text color={colors.white} fontWeight='bold' align='center'>
                        {t('item.discontinued')}
                    </Text>
                </Disabled>
            )}
        </ImageCard>
    );
}

const Disabled = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ImageCard = styled.div`
    border-radius: var(--radius-xs);
    flex-shrink: 0;
    height: 100px;
    overflow: hidden;
    max-width: 100px;
    min-width: 100px;
    width: 100px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Thumbnail = styled(Image)`
    height: 100%;
    object-fit: cover;
    width: 100%;
`;

export default CartImage;
